
namespace RioERP.Inventory {

    @Serenity.Decorators.registerClass()
    export class PendriveInwardDialog extends Serenity.EntityDialog<PendriveInwardRow, any> {
        protected getFormKey() { return PendriveInwardForm.formKey; }
        protected getIdProperty() { return PendriveInwardRow.idProperty; }
        protected getLocalTextPrefix() { return PendriveInwardRow.localTextPrefix; }
        protected getNameProperty() { return PendriveInwardRow.nameProperty; }
        protected getService() { return PendriveInwardService.baseUrl; }
        protected getDeletePermission() { return PendriveInwardRow.deletePermission; }
        protected getInsertPermission() { return PendriveInwardRow.insertPermission; }
        protected getUpdatePermission() { return PendriveInwardRow.updatePermission; }

        protected form = new PendriveInwardForm(this.idPrefix);

    }
}